<template>
    <div>
        <v-bottom-sheet v-model="dialog" v-if="showMobile" persistent hide-overlay>
            <v-sheet class="text-right">
                <v-btn
                    icon
                    color="primary"
                    class="btn-close"
                    @click="close">
                    <v-icon class="font-size-32 white rounded-circle"> mdi-close-circle</v-icon>
                </v-btn>
            <div
                class="d-flex flex-column justify-center align-center higlight-type-content"
            >
                <div
                    class="higlight-type-content d-flex flex-column justify-center align-center position-relative pa-4 w-100"
                >
                    <div class="h-type-img w-100 d-flex flex-row justify-start align-center">
                        <img :src="markierImg" width="32" height="32" alt="icono de marcador" />
                        <div class="align-middle text-left line-height-100">
                            <p class="font-size-16 font-weight-bolder ma-0 text--primary">
                                {{ $t('bookReading.marker') }}
                            </p>
                            <small class="font-size-12">Highlighting</small>
                        </div>
                    </div>
                    <div class="h-type-img w-100 mt-2 d-flex flex-row justify-start align-center">
                        <span class="primary--text text-justify line-height-130"
                            >{{ $t('bookReading.highlight_modal_msg') }}</span
                        >
                    </div>
                    <div class="w-100 py-3 d-flex flex-column justify-center align-center highlight-tomarkerd">
                        <v-slide-group
                                class="highlight-markerd"
                                mandatory
                            >
                            <v-slide-item
                                cols="6"
                                class="mx-1"
                                v-for="(highlightType, index) of highlightTypes"
                                :key="index"
                            >
                            <!-- :style="highlightType.id === typeSelected ? 'background-color:' + highlightTypes.classcolor + '; border-color: ' + highlightTypes.bordercolor : 'background-color:' + highlightTypes.classcolor + '; border-color: ' + highlightTypes.classcolor" -->
                            <!-- :style="highlightType.id == typeSelected ? `background-color: ${highlightType.classcolor} background-color: ${highlightTypes.classcolor}; border-color: ${highlightTypes.bordercolor}` : `background-color: ${highlightTypes.classcolor}; border-color: ${highlightTypes.classcolor}`" -->
                                <div
                                    :data-cy="`HighlightTypeSelect-${highlightType.value}-button`"
                                    :class="
                                        'd-flex flex-column justify-center align-center pa-3 border-radius-1 transition-all h-type ' +
                                        (highlightType.id === typeSelected ? 'active h-type--' + highlightType.classcolor : 'h-type--' + highlightType.classcolor)
                                    "
                                    :id="`h-type-${highlightType.id}`"
                                    @click="setSelectedType(highlightType.id)"
                                >
                                    <img width="48" :src="highlightType.img" alt="icono de marcador" />
                                    <span class="font-size-12">{{ highlightType.value }}</span>
                                </div>
                            </v-slide-item>
                        </v-slide-group>
                    </div>
                    <v-row class="w-100 mt-2 d-flex justify-center align-center">
                        <v-spacer></v-spacer>
                        <v-btn
                            data-cy="HighlightTypeSelect-save-button"
                            dark
                            class="px-16 py-5 bg-gradient-primary"
                            rounded
                            block
                            :loading="btnLoaded"
                            @click="saveMarker"
                        >
                            {{ $t('save') }}
                        </v-btn>
                    </v-row>
                </div>
            </div>
            </v-sheet>
        </v-bottom-sheet>
        
        <v-dialog 
            v-model="dialog" 
            v-if="!showMobile"
            persistent 
            content-class="highlight-modal"
            overlay-color="#514585FA"
            overlay-opacity="0.98"
            max-width="90vw"
            width="40%"
            >
            <div
                class="d-flex flex-column justify-center align-center higlight-type-content"
            >
                <div
                    class="higlight-type-content d-flex flex-column justify-center align-center position-relative pa-4 w-100"
                >
                    <div class="h-type-img w-100 d-flex flex-row justify-content-between align-center">
                        <div class="row ma-0 align-items-center">
                            <img :src="markierImg" width="32" height="32" alt="icono de marcador" class="mr-1" />
                            <div class="align-middle text-left line-height-100">
                                <p class="font-size-16 font-weight-bolder ma-0 text--primary">
                                    {{ $t('bookReading.marker') }}
                                </p>
                                <small class="font-size-12">Highlighting</small>
                            </div>
                        </div>
                        <v-btn
                            icon
                            color="primary"
                            class="btn-close"
                            @click="close">
                            <v-icon class="font-size-32 white rounded-circle"> mdi-close-circle</v-icon>
                        </v-btn>
                    </div>
                    <div class="h-type-img w-100 mt-2 d-flex flex-row justify-start align-center">
                        <span class="primary--text text-justify line-height-130"
                            >{{ $t('bookReading.highlight_modal_msg') }}</span
                        >
                    </div>
                    <div class="w-100 py-3 d-flex flex-column justify-center align-center highlight-tomarkerd">
                        <v-slide-group
                                class="highlight-markerd"
                                mandatory
                            >
                            <v-slide-item
                                cols="6"
                                class="mx-1"
                                v-for="(highlightType, index) of highlightTypes"
                                :key="index"
                            >
                            <!-- :style="highlightType.id === typeSelected ? 'background-color:' + highlightTypes.classcolor + '; border-color: ' + highlightTypes.bordercolor : 'background-color:' + highlightTypes.classcolor + '; border-color: ' + highlightTypes.classcolor" -->
                            <!-- :style="highlightType.id == typeSelected ? `background-color: ${highlightType.classcolor} background-color: ${highlightTypes.classcolor}; border-color: ${highlightTypes.bordercolor}` : `background-color: ${highlightTypes.classcolor}; border-color: ${highlightTypes.classcolor}`" -->
                                <div
                                    :data-cy="`HighlightTypeSelect-${highlightType.value}-button`"
                                    :class="
                                        'd-flex flex-column justify-center align-center pa-3 border-radius-1 transition-all h-type ' +
                                        (highlightType.id === typeSelected ? 'active h-type--' + highlightType.classcolor : 'h-type--' + highlightType.classcolor)
                                    "
                                    :id="`h-type-${highlightType.id}`"
                                    @click="setSelectedType(highlightType.id)"
                                >
                                    <img width="48" :src="highlightType.img" alt="icono de marcador" />
                                    <span class="font-size-12">{{ highlightType.value }}</span>
                                </div>
                            </v-slide-item>
                        </v-slide-group>
                    </div>
                    <v-row class="w-100 mt-2 d-flex justify-center align-center">
                        <v-spacer></v-spacer>
                        <v-btn
                            data-cy="HighlightTypeSelect-save-button"
                            dark
                            class="px-16 py-5 bg-gradient-primary"
                            rounded
                            block
                            :loading="btnLoaded"
                            @click="saveMarker"
                        >
                            {{ $t('save') }}
                        </v-btn>
                    </v-row>
                </div>
            </div>
        </v-dialog>
    </div>
</template>
<script>
/* eslint-disable global-require */
import { mapState } from 'vuex';

export default {
    props: {
        dialog: { type: Boolean, default: false },
    },
    data() {
        return {
            typeSelected: null,
            btnLoaded: false,
            
            markierImg: require('@/assets/img/icons/new-reading/highlighting-purple.svg'),
            highlightTypes: [
                {
                    id: 0,
                    value: this.$t('bookReading.characters'),
                    color: '#97ed57',
                    classcolor: 'green',
                    img: require('@/assets/img/icons/new-reading/highlight/icon-personajes.svg'),
                },
                {
                    id: 1,
                    value: this.$t('bookReading.actions'),
                    color: '#57d6ed',
                    classcolor: 'lightblue',
                    img: require('@/assets/img/icons/new-reading/highlight/icon-acciones.svg'),
                },
                {
                    id: 2,
                    value: this.$t('bookReading.vocabulary'),
                    color: '#ffdb39',
                    classcolor: 'yellow',
                    img: require('@/assets/img/icons/new-reading/highlight/icon-vocabulario.svg'),
                },
                {
                    id: 3,
                    value: this.$t('bookReading.places'),
                    color: '#ff44b9',
                    classcolor: 'pink',
                    img: require('@/assets/img/icons/new-reading/highlight/icon-lugares.svg'),
                },
            ],
        }
    },
    methods: {
        close() {
            this.$emit('close-modal')
        },
        saveMarker() {
            this.$emit('save-highlight')
        },
        setSelectedType(id) {
            this.typeSelected = id
        },
        resetVars() {
            this.typeSelected = null
            this.btnLoaded = false
        },
    },
    computed: {
    ...mapState({
        showMobile: (state) => state.isMobile,
      })
    },
}
</script>
<style lang="scss">
.h-type-img {
    z-index: 300;
}
.h-type-img img {
    height: 5vh;
    z-index: 10;
}
.higlight-type-content {
    border-radius: 26px;
    background: #fff;
}
.h-type {
    background: white;
    border-width: 3px;
    border-style: solid;
    min-width: 95px;
    &--green{
        background-color: #E3FCEB;
        border-color: #E3FCEB;
        &.active{
            border-color: #3FB16D;
        }
    }
    &--lightblue{
        background-color: #E3F2FC;
        border-color: #E3F2FC;
        &.active{
            border-color: #33B2F5;
        }
    }
    &--yellow{
        background-color: #FBF5E4;
        border-color: #FBF5E4;
        &.active{
            border-color: #F4DFA0;
        }
    }
    &--pink{
        background-color: #FEDFEF;
        border-color: #FEDFEF;
        &.active{
            border-color: #F2A0D0;
        }
    }
}

.h-type:hover {
    background: rgb(216, 216, 216);
    cursor: pointer;
}

.h-type.active {
    border-width: 3px;
    border-style: solid;
}

.btn-cls {
    top: 1vh;
    right: 1vh;
    z-index:10;
}
.v-bottom-sheet{
  position: relative;
  .btn-close{
    position: absolute;
    right: 24px;
    left: inherit;
    top: 1em;
    z-index: 400!important;
  }
}
.highlight-modal{
    border-radius: 1em;
    padding-top: 0!important;
    .btn-close{
        left: 0;
        top: 0;
    }
}
</style>
